import React from 'react';
import { motion } from 'framer-motion';
import { DollarSign, BookOpen, Heart, Users } from 'lucide-react';
import { smoothScrollTo } from './CTAButton';
export function BonusSection() {
  const bonuses = [{
    id: 1,
    title: 'Curso para Optimizar tu Dinero en 5 Pasos',
    desc: 'Aprendé principios simples para mejorar tu relación con el dinero.',
    icon: <DollarSign className="w-8 h-8 text-green-400" data-id="element-37" />,
    bg: 'from-green-900 to-black'
  }, {
    id: 2,
    title: 'Curso de Lectura Rápida',
    desc: 'Aprendé técnicas para leer más rápido y absorber mejor la información.',
    icon: <BookOpen className="w-8 h-8 text-blue-400" data-id="element-38" />,
    bg: 'from-blue-900 to-black'
  }, {
    id: 3,
    title: 'Ebook de Gratitud y Amor Propio',
    desc: 'Ejercicios simples para mejorar tu bienestar emocional.',
    icon: <Heart className="w-8 h-8 text-pink-400" data-id="element-39" />,
    bg: 'from-pink-900 to-black'
  }, {
    id: 4,
    title: 'Ebook de Relaciones y Conexión Personal',
    desc: 'Ideas prácticas para mejorar tus relaciones y tu comunicación.',
    icon: <Users className="w-8 h-8 text-purple-400" data-id="element-40" />,
    bg: 'from-purple-900 to-black'
  }];
  return <section className="py-8 px-4 bg-[#111827]" data-id="element-41">
      <div className="max-w-4xl mx-auto" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-43">
          <div className="text-center mb-5" data-id="element-44">
            <h2 className="text-3xl md:text-4xl font-black text-[#8FF650] mb-1 uppercase tracking-tight" data-id="element-45">
              🎁 REGALOS ESPECIALES
            </h2>
            <h3 className="text-xl md:text-2xl font-black text-white mb-1" data-id="element-46">
              BONOS INCLUIDOS HOY
            </h3>
            <p className="text-sm font-bold text-gray-400 uppercase tracking-widest" data-id="element-47">
              (Sin costo adicional)
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-5" data-id="element-48">
            {bonuses.map(bonus => <button key={bonus.id} onClick={() => smoothScrollTo('compra', 2500)} className="group block w-full text-left bg-gray-900 rounded-xl p-3 border border-gray-700 hover:border-[#8FF650] transition-colors shadow-lg" data-id="element-49">
                <div className="flex gap-3 items-center" data-id="element-50">
                  <div className={`w-14 h-14 rounded-lg bg-gradient-to-br ${bonus.bg} flex items-center justify-center flex-shrink-0 border border-gray-800 relative`} data-id="element-51">
                    <div className="absolute -top-1 -right-1 bg-[#8FF650] text-black text-[8px] font-black px-1 rounded-sm" data-id="element-52">
                      #{bonus.id}
                    </div>
                    {bonus.icon}
                  </div>

                  <div className="flex-1 min-w-0" data-id="element-53">
                    <h4 className="text-sm font-black text-white mb-0.5 leading-tight" data-id="element-54">
                      {bonus.title}
                    </h4>
                    <p className="text-xs text-gray-400 font-medium leading-tight" data-id="element-55">
                      {bonus.desc}
                    </p>
                    <div className="flex items-center gap-2 mt-1" data-id="element-56">
                      <span className="text-gray-500 font-bold line-through text-xs" data-id="element-57">
                        $14.999
                      </span>
                      <span className="text-sm font-black text-[#8FF650]" data-id="element-58">
                        GRATIS
                      </span>
                    </div>
                  </div>
                </div>
              </button>)}
          </div>

          <div className="text-center bg-[#8FF650] py-3 px-4 rounded-xl shadow-lg" data-id="element-59">
            <p className="text-lg md:text-xl font-black text-black uppercase" data-id="element-60">
              Estos bonos son GRATIS por el día de hoy
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}